module.exports = __webpack_public_path__ + "static/media/18.ffbb5bfd.gif";